<template lang="pug">
  .image-ctn
    .image
      svg.shape-mask(viewBox='0 0 400 500', preserveAspectRatio='none')
        path(style='fill:#FDFAF5;', d='M400,460c0,0-17,40-106,40s-97-40-187-40S0,490,0,490V0c0,0,18,0,112,0s100,0,186,0s102,0,102,0V460z')
      transition(name='shape-mask', @enter='enter', @leave='leave', mode='out-in', :css='false', appear)
        .img-wrap(:key='image')
          img(v-if='image !== null', :srcset='image.srcSet', :src='image.images ? image.images[2].path : image.src', :key='image')
          gmap-map(v-if='image !== null && image.center !== undefined', ref='gmap', :center='image.center', :zoom='12', :options='image.options', gestureHandling='cooperative', :key='image')
            gmap-marker(:position='image.center', icon=' ', :label='image.marker', :key='image')
    .clear
</template>



<script>
  import {TweenLite, Power3} from 'gsap'

  export default {
    props: ['image'],
    data () {
      return {
        shape: {
          enter: 'M400,500c0,0-17,0-106,0s-97,0-187,0S0,500,0,500V30C0,30,18,0,112,0s100,40,186,40s102-20,102-20V500z',
          leave: 'M400,460c0,0-17,40-106,40s-97-40-187-40S0,490,0,490V0c0,0,18,0,112,0s100,0,186,0s102,0,102,0V460z',
          rect: 'M400,500c0,0-17,0-106,0s-97,0-187,0S0,500,0,500V0c0,0,18,0,112,0s100,0,186,0s102,0,102,0V500z'
        }
      }
    },
    methods: {
      morph (svgFrom, svgTo, d, x) {
        return TweenLite.fromTo('.shape-mask path', d / 1000, {morphSVG: svgFrom}, {morphSVG: svgTo, delay: x / 1000, ease: Power3.easeInOut})
      },
      enter (el, done) {
        let shape = document.querySelector('.shape-mask')
        shape.style.transformOrigin = 'center bottom'
        TweenLite.to('.image-ctn', 1, {opacity: 1})
        TweenLite.to(shape, 1, {
          scaleY: 0,
          ease: Power3.easeInOut,
          onStart: function () {
            shape.style.transformOrigin = 'center bottom'
          },
          onCompleteScope: this,
          onComplete: function () {
            shape.style.transformOrigin = ''
            setTimeout(() => {
              this.morph(this.shape.enter, this.shape.leave, 125, 0)
              done()
            }, 500)
          }
        })
        this.morph(this.shape.rect, this.shape.enter, 500, 250)
      },
      leave (el, done) {
        let shape = document.querySelector('.shape-mask')
        // anime({
        //   targets: shape,
        //   duration: 500,
        //   scaleY: 1,
        //   delay: 50,
        //   easing: 'easeInOutQuart',
        //   complete: function () {
        //     done()
        //   }
        // })
        TweenLite.to(shape, 1, {
          scaleY: 1,
          ease: Power3.easeInOut,
          onComplete: function () {
            setTimeout(() => {
              done()
            }, 500)
          }
        })
        this.morph(this.shape.leave, this.shape.rect, 500, 250)
      }
    }
  }
</script>

<style lang="scss">
  @import "~utils";
  .image-ctn {
    background: $light-blue;
    padding: $gutter*2 0;
    margin-top: 3.5rem;
    opacity: 0;
    @include desktop {
      width: 50%;
      text-align: center;
      display: inline-block;
      padding: 0;
      padding-bottom: $gutter*5;
      background: transparent;
      margin-top: 0;
    }
    .image {
      position: relative;
      overflow: hidden;
      background: $light-gold;
      @include grid-column(6);
      @include grid-media($desktop-grid) {
        @include grid-column(8);
        margin: 0 auto;
        float: none;
        display: inline-block;
      }
      .shape-mask {
        position: absolute;
        top: 0;
        left: 0;
        min-width: 100%;
        height: 100%;
        z-index: 10;
        display: block;
        transform-origin: center top;
        transform: translate3d(0,0,0);
        transform-style: preserve-3d;
        backface-visibility: hidden;
      }
      img {
        display: block;
        backface-visibility: initial;
      }
      .vue-map-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Image.vue?3677b6df